import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Grid from "@material-ui/core/Grid";
import { getCurrUsername, getCurrAcc } from "./utils";

// This is the blockchain object we receive using web3
const APIobject = 100;

const addresses = [
    "1 Material-UI Drive",
    "Reactville",
    "Anytown",
    "99999",
    "USA",
];

const useStyles = makeStyles((theme) => ({
    listItem: {
        padding: theme.spacing(1, 0),
    },
    total: {
        fontWeight: 700,
    },
    title: {
        marginTop: theme.spacing(2),
    },
}));

const RedTextTypography = withStyles({
    root: {
        color: "red",
    },
})(Typography);

const GreenTextTypography = withStyles({
    root: {
        color: "green",
    },
})(Typography);

const DesiredTypography = (props) => {
    var result;

    if (props.color === "red") {
        result = <RedTextTypography> -{props.value} </RedTextTypography>;
    } else {
        result = <GreenTextTypography> +{props.value} </GreenTextTypography>;
    }

    return result;
};

export default function Review({ username, amount, address }) {
    const classes = useStyles();

    const products = [
        {
            name: "BlockRolls",
            desc: "Amount of BlockRoll transferred",
            color: "red",
            price: amount,
        },
        {
            name: "Trasaction Fees",
            desc: "Amount deducted for transaction",
            color: "red",
            price: "0",
        },
    ];

    const payments = [
        { name: "Reciever", detail: username },
        { name: "Reciever Account", detail: address },
    ];

    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom>
                Transaction Summary
            </Typography>
            <List disablePadding>
                {products.map((product) => (
                    <ListItem className={classes.listItem} key={product.name}>
                        <ListItemText
                            primary={product.name}
                            secondary={product.desc}
                        />
                        <DesiredTypography
                            color={product.color}
                            value={product.price}
                        ></DesiredTypography>
                    </ListItem>
                ))}

                <ListItem className={classes.listItem}>
                    <ListItemText primary="Total" />
                    <Typography variant="subtitle1" className={classes.total}>
                        {amount}
                    </Typography>
                </ListItem>
            </List>
            <Grid container spacing={2}>
                <Grid item container direction="column" xs={12}>
                    <Typography
                        variant="h6"
                        gutterBottom
                        className={classes.title}
                    >
                        Payment details
                    </Typography>
                    <Grid container>
                        {payments.map((payment) => (
                            <React.Fragment key={payment.name}>
                                <Grid item xs={6}>
                                    <Typography gutterBottom>
                                        {payment.name}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography noWrap={true} gutterBottom>
                                        {payment.detail}
                                    </Typography>
                                </Grid>
                            </React.Fragment>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
